module.exports = __webpack_public_path__ + "img/frontale_sole_orange.png";